'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('survey-browser', {
      url: '/survey/data-browser/:id',
      template: '<survey-browser></survey-browser>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/survey/browser/survey-browser.routes.js